import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { withRouter } from "react-router-dom";

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Categories from './categories';
import Products from './products';


const AntTabs = withStyles({
    root: {
      minHeight: 32,
      borderBottom: '1px solid inherit',
      marginBottom: 16,
    },
    indicator: {
      maxWidth: 24,
      height: 2,
      backgroundColor: '#326DFF',
    },
  })(Tabs);

  const AntTab = withStyles((theme) => ({
    root: {
      color: '#476282',
      minWidth: 30,
      minHeight: 32,
      marginRight: 30,
      fontFamily: 'Poppins, sans-serif',
      fontSize: 16,
      fontWeight: 600,
      textTransform: 'inherit',
      textAlign: 'left',
      padding: 0,
      '&:last-child': {
        marginRight: 0,
      },
      '&:hover': {
        color: '#326DFF',
        opacity: 1,
      },
      '&$selected': {
        color: '#326DFF',
        fontWeight: 600,
        textAlign: 'left',
      },
      '&:focus': {
        color: '#326DFF',
      },
    },
    selected: {},
  }))((props) => <Tab disableRipple {...props} />);

const TabsComponent = (props) => {
    const classes = useStyles();
    const { categories, products, categoriesOrder , hiddenCategories, hiddenProducts, isNewAdmin } = props;
    const [selectedTab, setSelectedTab] = React.useState(0);

    const handleChange = (event, newValue) => {
      setSelectedTab(newValue);
    };

    return (
      <div className={classes.tabsComponent}>
        <AntTabs value={selectedTab} onChange={handleChange}>
          <AntTab label="Категории" />
          <AntTab label="Товары" />
        </AntTabs>
        {selectedTab === 0 && <Categories categories={categories} categoriesOrder={categoriesOrder} hiddenCategories={hiddenCategories} isNewAdmin={isNewAdmin}/>}
        {selectedTab === 1 && <Products categories={categories} categoriesOrder={categoriesOrder} products={products} hiddenProducts={hiddenProducts} isNewAdmin={isNewAdmin} />}
      </div>
    );
}

const useStyles = makeStyles(theme => ({
    tabsComponent: {
    },
    tabs: {
        marginTop: 20,
        minHeight: 'auto',
    },
    tab: {
        minWidth: 'auto',
        minHeight: 'auto',
        padding: 0,
        paddingRight: 30,
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 600,
        fontSize: 16,
        lineHeight: '28px',
        textTransform: 'inherit',
        color: '#476282',
        '&:last-child': {
            // background: 'red'
        },
        '&.MuiTouchRipple-root': {

        }
    },
    tabHeader: {
        margin: '16px 0 26px 10px',
    },
    discountsAndPromotions: {
       
    },
    tabLinks: {
      display: 'flex',
    },
    tabLink: {
      position: 'relative',
      fontFamily: 'Poppins, sans-serif',
      fontSize: 16,
      fontWeight: 600,
      lineHeight: '28px',
      marginRight: 26,
      textDecoration: 'none',
      color: '#476282',
      '&.active': {
        color: '#326DFF',
        '&::before': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '50%',
          height: 2,
          background: '#326DFF',
        }
      }
    }
}))

export default withRouter(TabsComponent);